import React, { useEffect, useLayoutEffect } from 'react';
import Navbar from './NavBar.js';
import BackgroundImage from './StartPage.js';
import Services from './Services.js';
import CTA from './CTA.js';
import HomeTimelineSection from './HomeTimelineSection.js';
import LocationPresence from './LocationPresence.js';
import EndCTA from './EndCTA.js';
import Footer from './Footer.js';


function Home({ adminMode = false, onEditHero = () => {}, onAdminLogout = () => {}, isAdminLoggedIn = false }) {
    // Home section order is intentional and matches marketing flow:
    // Hero -> Services -> CTA -> Timeline -> Presence -> Contact CTA.
    useLayoutEffect(() => {
        let retryTimer = null;
        const shouldScroll = window.location.hash === '#tjanster' || window._pendingServicesScroll;
        if (!shouldScroll) {
            return undefined;
        }

        const attemptScroll = (remaining = 6) => {
            const section = document.getElementById('tjanster');
            if (section) {
                section.scrollIntoView({ behavior: 'auto', block: 'start' });
                window._pendingServicesScroll = false;
                return;
            }
            if (remaining > 0) {
                retryTimer = window.setTimeout(() => attemptScroll(remaining - 1), 50);
            }
        };

        attemptScroll();
        return () => {
            if (retryTimer) {
                window.clearTimeout(retryTimer);
            }
        };
    }, []);

    useEffect(() => {
        const scrollToServicesSmooth = () => {
            if (window.location.hash !== '#tjanster') return;
            const section = document.getElementById('tjanster');
            if (section) {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };

        const handleHashChange = () => {
            scrollToServicesSmooth();
        };

        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    return (
        <div className="home-page">
            <header className="header">
                <Navbar
                    adminMode={adminMode}
                    isAdminLoggedIn={isAdminLoggedIn}
                    onAdminLogout={onAdminLogout}
                />
                <BackgroundImage adminMode={adminMode} onEditHero={onEditHero} />
                <Services adminMode={adminMode} />
                <CTA adminMode={adminMode} />
                <HomeTimelineSection adminMode={adminMode} />
                <LocationPresence />
                <EndCTA />
            </header>
            <footer>
                <Footer />
            </footer>
        </div>
    );

}

export default Home;
